// extracted by mini-css-extract-plugin
export default {"text":"ProgressBar_text__gY1Bi","progressBar":"ProgressBar_progressBar__NZBxv","progress":"ProgressBar_progress__nqdyy"};